import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ReferencesPage from "@/pages/ReferencesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BuilderPage from "@/pages/BuilderPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  return (
    <div className="min-h-screen bg-[#030303]">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#0A0A0A',
            color: '#fff',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            fontFamily: 'Inter, sans-serif'
          }
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/szolgaltatasok" element={<ServicesPage />} />
            <Route path="/referenciak" element={<ReferencesPage />} />
            <Route path="/rolam" element={<AboutPage />} />
            <Route path="/kapcsolat" element={<ContactPage />} />
            <Route path="/tervezo" element={<BuilderPage />} />
            <Route path="/adatvedelem" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-szabalyzat" element={<CookiePolicyPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
